// Patrones Code 128 (ancho de barra/espacio alternados) para los valores 0-105; el 106 es el stop.
const PATTERNS = (
  '212222 222122 222221 121223 121322 131222 122213 122312 132212 221213 221312 231212 112232 122132 122231 113222 ' +
  '123122 123221 223211 221132 221231 213212 223112 312131 311222 321122 321221 312212 322112 322211 212123 212321 ' +
  '232121 111323 131123 131321 112313 132113 132311 211313 231113 231311 112133 112331 132131 113123 113321 133121 ' +
  '313121 211331 231131 213113 213311 213131 311123 311321 331121 312113 312311 332111 314111 221411 431111 111224 ' +
  '111422 121124 121421 141122 141221 112214 112412 122114 122411 142112 142211 241211 221114 413111 241112 134111 ' +
  '111242 121142 121241 114212 124112 124211 411212 421112 421211 212141 214121 412121 111143 111341 131141 114113 ' +
  '114311 411113 411311 113141 114131 311141 411131 211412 211214 211232'
).split(' ');
const STOP = '2331112';
const START_B = 104;

/** Codifica texto ASCII imprimible (32-126) en Code 128-B; devuelve los anchos de módulo alternando barra/espacio. */
export const encodeCode128B = (text: string): number[] => {
  const values = [START_B];
  for (let i = 0; i < text.length; i++) {
    const code = text.charCodeAt(i);
    if (code < 32 || code > 126) throw new Error('Carácter no soportado en Code 128-B');
    values.push(code - 32);
  }
  const checksum = values.reduce((sum, v, i) => sum + v * (i === 0 ? 1 : i), 0) % 103;
  values.push(checksum);
  const widths: number[] = [];
  values.forEach(v => PATTERNS[v].split('').forEach(w => widths.push(Number(w))));
  STOP.split('').forEach(w => widths.push(Number(w)));
  return widths;
};
